import React from 'react';
import { Switch } from './ui/switch';
import { Label } from './ui/label';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';
import { DollarSign, Receipt } from 'lucide-react';

const PricingModeSelector = ({
  value = 'tax_exclusive',
  onChange,
  disabled = false,
  size = 'medium',
  showLabels = true,
  showTooltips = true,
  variant = 'standard',
  className = ''
}) => {
  const isChecked = value === 'tax_inclusive';

  const handleChange = (checked) => {
    if (!disabled && onChange) {
      onChange(checked ? 'tax_inclusive' : 'tax_exclusive');
    }
  };

  const iconSize = size === 'small' ? 'h-4 w-4' : 'h-5 w-5';

  const switchElement = (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Tax Exclusive Label */}
      <div
        className={`flex items-center gap-1.5 cursor-pointer transition-opacity ${
          isChecked ? 'opacity-50' : 'opacity-100'
        }`}
        onClick={() => !disabled && handleChange(false)}
      >
        <DollarSign className={`${iconSize} ${!isChecked ? 'text-primary' : 'text-muted-foreground'}`} />
        {showLabels && (
          <Label
            className={`cursor-pointer select-none ${
              variant === 'compact' ? 'text-xs' : 'text-sm'
            } ${!isChecked ? 'font-medium text-foreground' : 'text-muted-foreground'}`}
          >
            {variant === 'compact' ? '未税' : '未税价格'}
          </Label>
        )}
      </div>

      {/* Switch */}
      <Switch
        checked={isChecked}
        onCheckedChange={handleChange}
        disabled={disabled}
        className={size === 'small' ? 'h-5 w-9' : ''}
      />

      {/* Tax Inclusive Label */}
      <div
        className={`flex items-center gap-1.5 cursor-pointer transition-opacity ${
          isChecked ? 'opacity-100' : 'opacity-50'
        }`}
        onClick={() => !disabled && handleChange(true)}
      >
        <Receipt className={`${iconSize} ${isChecked ? 'text-primary' : 'text-muted-foreground'}`} />
        {showLabels && (
          <Label
            className={`cursor-pointer select-none ${
              variant === 'compact' ? 'text-xs' : 'text-sm'
            } ${isChecked ? 'font-medium text-foreground' : 'text-muted-foreground'}`}
          >
            {variant === 'compact' ? '含税' : '含税价格'}
          </Label>
        )}
      </div>
    </div>
  );

  if (showTooltips) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            {switchElement}
          </TooltipTrigger>
          <TooltipContent>
            <p>{isChecked
              ? '当前：含税价格模式 - 手动输入含税价格，系统自动计算不含税价格'
              : '当前：未税价格模式 - 手动输入不含税价格，系统自动计算含税价格'
            }</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return switchElement;
};

export default PricingModeSelector;
